import styled from 'styled-components'

import typeStyle from '../../styles/typeStyle'

import InstantBookIcon from '../icons/InstantBook'

const CustomBadge = styled.div<{ compact?: boolean }>`
  ${typeStyle('-ds-font-caption-sm')}
  display: inline-block;
  padding: 0 6px;

  width: auto;
  height: 20px;
  line-height: 20px;

  margin: 0;

  letter-spacing: 0.8px;
  text-transform: uppercase;
  white-space: nowrap;

  border-radius: 5px;

  color: ${({ theme, compact }) =>
    compact
      ? theme?.['-ds-core-200']?.value
      : theme?.['-ds-neutral-700']?.value};
  background-color: ${({ theme, compact }) =>
    compact ? 'transparent' : theme?.['-ds-core-200']?.value};

  svg {
    display: inline-block;
    vertical-align: middle;
    height: ${({ compact }) => (compact ? '18px' : '10px')};
    margin-right: ${({ compact }) => (compact ? '0' : '6px')};
  }
`

const InstantBookBadge = ({ compact }: { compact?: boolean }) => (
  <CustomBadge compact={compact} data-testid="instant-book">
    <InstantBookIcon />
    {!compact && <span>Instant Book</span>}
  </CustomBadge>
)

export default InstantBookBadge
